import { loadable } from 'react-lazily/loadable';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { TransactionFunctions, UserFunctions } from '../redux/actions/AppActionFunctions/AppActions';
import { ventureImports } from '../venture';
const { DefaultDashboard } = loadable(() => import(/* webpackPreload: true */ '../components/DefaultDashboard'));
const { LazyQueryTableShim } = loadable(() => import(/* webpackPreload: true */ '../v2/components/generic/Dashboard/Lazy/QueryTable'));
const debug = process.env.REACT_APP_DEBUG && false;
const mapStateToProps = (state, ownProps) => {
    debug && console.log('Dashboard own props', ownProps);
    return {
        isAuthenticated: state.AccessReducer.isAuthenticated,
        ...state.AppReducer,
    };
};
const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        init: (cognitoUser, userGroupRoles) => {
            debug && console.log('Dashboard Container requested init', ownProps);
        },
        userFunctions: bindActionCreators(UserFunctions, dispatch),
        transactionFunctions: bindActionCreators(TransactionFunctions, dispatch),
    };
};
const ResolvedDashboard = ventureImports.dashboardLazyTableConfig ? LazyQueryTableShim : DefaultDashboard;
export default connect(mapStateToProps, mapDispatchToProps)(ResolvedDashboard);
